module.exports = __webpack_public_path__ + "static/media/Poppins-ExtraBold.496488f3.woff2";